
const inputs = document.querySelectorAll('.otp-input');
inputs.forEach((input, idx) => {
  input.addEventListener('input', (e) => {
    // Strip non-digits
    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 1);
    if (e.target.value && idx < inputs.length - 1) inputs[idx + 1].focus();
    // Auto-submit when all 6 digits entered
    const code = Array.from(inputs).map((i) => i.value).join('');
    if (code.length === 6) document.getElementById('otp-form').requestSubmit();
  });
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Backspace' && !e.target.value && idx > 0) {
      inputs[idx - 1].focus();
      inputs[idx - 1].value = '';
      e.preventDefault();
    } else if (e.key === 'ArrowLeft' && idx > 0) {
      inputs[idx - 1].focus();
    } else if (e.key === 'ArrowRight' && idx < inputs.length - 1) {
      inputs[idx + 1].focus();
    }
  });
  input.addEventListener('paste', (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData?.getData('text') || '').replace(/\D/g, '').slice(0, 6);
    pasted.split('').forEach((c, i) => { if (inputs[i]) inputs[i].value = c; });
    inputs[Math.min(pasted.length, inputs.length - 1)].focus();
    if (pasted.length === 6) document.getElementById('otp-form').requestSubmit();
  });
});

document.getElementById('otp-form').addEventListener('submit', (e) => {
  e.preventDefault();
  e.stopPropagation();
  // Simulate success
  window.location.href = 'index.html';
});

// Countdown timer
let secs = 4 * 60 + 59;
const timer = document.getElementById('otp-timer');
const tick = setInterval(() => {
  secs -= 1;
  if (secs <= 0) {
    clearInterval(tick);
    timer.innerHTML = '<a href="#">Code expired — resend</a>';
    return;
  }
  const m = String(Math.floor(secs / 60)).padStart(2, '0');
  const s = String(secs % 60).padStart(2, '0');
  timer.innerHTML = `Expires in <strong>${m}:${s}</strong>`;
}, 1000);
